import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import chatReducer from '../features/chat/chatSlice';
import canvasReducer from '../features/canvas/canvasSlice';
import authReducer from '../features/auth/authSlice';
import orderReducer from '../features/order/orderSlice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['chat', 'canvas', 'order', 'auth'] // Persist chat, canvas, order, and auth slices
};

const appReducer = combineReducers({
  chat: chatReducer,
  canvas: canvasReducer,
  auth: authReducer,
  order: orderReducer,
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === 'auth/logoutSuccess') {
    // This will reset the state of all slices to their initial state
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
